<div id="partnerContentPages" class="pages_tabs">
  <div id="partnerPagesContent" class="pages_content">
    <div id="contentHeading" class="heading" [ngClass]="{'heading_hotspot' : pageGrpForm?.layout === 4}">{{contentName}}
      - <span i18n="@@partner-content-page.page.page">PAGE
        {{pageNumber}}</span></div>
    <form class="create_partner_content layout_one" *ngIf="pageGrpForm">
      <!-- 1st Column - Theme and Color Info -->
      <div id="themeAndColorInfo" class="color_info_col"
        [ngClass]="{'color_info_col_hotspot': pageGrpForm.layout === 4}">
        <div id="colorPicker" class="color-picker-group">
          <label for=""><span i18n="@@partner-content-page.theme.theme">Theme</span></label>
          <div id="themePicker" class="theme_picker_button default" (click)="openColPicModal()">
            <span class="text_color" [style.background-color]="pageGrpForm.bcolor"></span>
            <span class="bg_color" [style.background-color]="pageGrpForm.bgcolor"></span>
          </div>
        </div>
        <div>
          <div id="fontColorPicker" class="color-picker-group">
            <label for=""><span i18n="@@partner-content-page.font-color.font-color">Font color</span>
              <img *ngIf="pageGrpForm.layout === 4"
              class="round-info-icon" placement="top"
              [ngbPopover]="fontColorContent" container="body" alt="font color content"
              triggers="mouseenter:mouseleave" />
              <ng-template #fontColorContent>
                <span>The font color set here applies to both the heading and body text of all hotspots.
                  To customize the heading and body colors for each hotspot individually, 
                  use the color mixer for the heading and/or body within the hotspot.</span>
              </ng-template>
            </label>
            <div></div>
            <input readonly *ngIf="pageGrpForm.layout !== 4" [(colorPicker)]="pageGrpForm.hcolor" [cpPosition]="'right'"
              [style.background]="pageGrpForm.hcolor" class="color_picker_button" name="hcolor"
              (colorPickerChange)="onFontColorChange()" />
            <div *ngIf="pageGrpForm.layout === 4" readonly [(colorPicker)]="pageGrpForm.hcolor" [cpPosition]="'right'"
              [style.background]="pageGrpForm.hcolor" class="color_picker_button color_picker_line" name="hcolor"
              (colorPickerChange)="onFontColorChange()">
              <span [ngClass]="{'font-color-divider': isFontColorStruckOff}"></span>
            </div>
          </div>
          <div id="backgroundColorPicker" class="color-picker-group">
            <label for=""><span i18n="@@partner-content-page.bgcolor.background-color">Background color</span></label>
            <div></div>
            <input readonly [(colorPicker)]="pageGrpForm.bgcolor" [cpPosition]="'right'"
              [style.background]="pageGrpForm.bgcolor" class="color_picker_button" name="bgcolor"
              (colorPickerChange)="emitPageDataToPreview()" />
          </div>
        </div>
      </div>
      <div class="inline_separator"></div>

      <!-- 2nd Column - Main Content Info -->
      <div id="partnerContentSecondColumn" class="second_column">
        <div id="secondColoumnInfo" class="d-flex second_column_info">
          <div id="columnHeading" class="form-group" *ngIf="pageGrpForm.layout !== 4">
            <label for="heading">
              <span i18n="@@partner-content-page.heading.heading">Heading</span>
              <span class="text-muted ml-1" i18n="@@partner-content-page.max-heading.max-50-characters">(Max 100
                characters)</span>
            </label>
            <div id="headingInput" class="input-group">
              <input type="text" class="form-control" [placeholder]="headingPlaceHolderText"
                [(ngModel)]="pageGrpForm.heroImageContent.heading" name="heading" (keyup)="emitPageDataToPreview()"
                maxlength="100" />
            </div>
          </div>
          <div class="mb-3 d-flex" id="hotspotConDFlex" *ngIf="pageGrpForm.layout === 4">
            <div class="tab-container" id="tabContainer">
              <ng-container *ngFor="let tab of tabs; let i = index">
                <div class="tab" [ngClass]="selectedTabIndex === i ? 'active-tab':'inactive-tab'"
                  (click)="selectTab(i)">
                  <span id="hotspot1">{{ tab.name }}</span>
                  <span *ngIf="i === selectedTabIndex && tabs.length > 1" (click)="removeTab(i, $event)"
                    class="hotspot_crossmark" alt="hotspot cross symbol"></span>
                </div>
              </ng-container>
              <!-- Add Hotspot Button -->
              <div class="add-hotspot-main" [ngClass]="tabs.length >= maxTabs ? 'add-hotspot-main-space':''">
                <div (click)="addTab()" *ngIf="tabs.length < maxTabs" class="tab add-hotspot">
                  <span i18n="@@partner-content-page.add-hotspot-btn.add-hotspot"><img class="hotspot_add_mark"
                      alt="plus_hotspot"> Add Hotspot</span>
                </div>
              </div>
            </div>
          </div>
          <div id="columnHeading" class="form-group column-heading" *ngIf="pageGrpForm.layout === 4">
            <div class="d-flex">
              <div>
                <label for="heading">
                  <span>{{ tabs[selectedTabIndex]?.heading || 'Heading 1' }}</span> <span class="coral">*</span>
                  <span class="text-muted ml-1" i18n="@@partner-content-page.max-heading.max-200-characters">(Max 200
                    characters)</span>
                </label>
                <div id="headingInput" class="input-group">
                  <input type="text" class="form-control" [placeholder]="headingPlaceHolderText"
                    [ngClass]="{'has-error': showHeadingMessage}" (input)="getImageStatus()"
                    [(ngModel)]="pageGrpForm.hotspotImageVideoContent.heading" (ngModelChange)="onHeadingChange($event)"
                    name="headings" maxlength="200" />
                  <em class="err_icon_lang" *ngIf="showHeadingMessage"></em>
                </div>
                <div id="headingMandate" class="formfield_err_msg" *ngIf="showHeadingMessage"><span i18n="@@partner-content-page.heading-should-not-be-empty">Heading should not be empty</span></div>
                    <div>
                      <span class="formfield_err_msg" *ngIf="isHeadingMaxLengthReached">Heading Text cannot be more than 200 characters.</span>
                    </div>
              </div>
              <div id="ColorPicker" class="color-picker-group">
                <label for=""><span i18n="@@page.content.color">Color</span></label>
                <div></div>
                <input readonly [(colorPicker)]="pageGrpForm.hotspotImageVideoContent.headingColor"
                  [cpPosition]="'right'" [style.background]="pageGrpForm.hotspotImageVideoContent.headingColor"
                  class="color_picker_button hotspot_input" name="headingcolor"
                  (colorPickerChange)="onHeadingBodyColorChange()" />
              </div>
            </div>
            <div id="imageVideoUpload" class="form-group-upload" *ngIf="pageGrpForm.layout === 4">
              <label for="image/video">
                <span i18n="@@page.content.image-video">Image/Video</span> <span class="coral">*</span>
                &nbsp; <img class="round-info-icon" placement="top" [ngbPopover]="popContent" 
                container="body" alt="font color content" triggers="mouseenter:mouseleave" />             
              </label>
              <button type="button" class="btn btn-primary left_icon_btn" (click)="openPopup(imagePopup,'image-video')">
                <img class="image_icon" alt="Image or video" />
                <span i18n="@@page.content.upload-image-video">Upload Image/Video</span>
              </button>
              <div id="column2ImageVideoName" class="name-break"
                *ngIf="(selectImageVideoHotspotData[0]?.imageAName || selectImageVideoHotspotData[0]?.videoName)"
                ngbTooltip="{{selectImageVideoHotspotData[0]?.imageAName || selectImageVideoHotspotData[0]?.videoName}}">
                {{selectImageVideoHotspotData[0]?.imageAName || selectImageVideoHotspotData[0]?.videoName}}</div>
              <div id="headingMandate" class="formfield_err_msg" *ngIf="showImageVideoMessage"><span i18n="@@partner-content-page.select-image-or-video">Select Image/Video</span></div>
            </div>
          </div>
          <div id="uploadFormLayout1" class="form-group-upload" *ngIf="pageGrpForm.layout === 1">
            <label for="heroImage">
              <span i18n="@@partner-content-page.hero-image.hero-image">Hero Image</span> <span class="coral">*</span>
              &nbsp; <img class="round-info-icon" placement="top" [ngbPopover]="popContentImage"
              container="body" alt="font color content" triggers="mouseenter:mouseleave" />            
              <img class="image_icon" alt="hero image" />
            </label>
            <button type="button" class="btn btn-primary left_icon_btn" (click)="openPopup(imagePopup,'hero')">
              <img class="image_icon" alt="add image" />
              <span i18n="@@partner-content-page.add-image.add-image">Add Image</span>
            </button>
            <div id="heroImageName" class="name-break" *ngIf="pageGrpForm.heroImageContent.heroImageName"
              ngbTooltip="{{pageGrpForm.heroImageContent.heroImageName}}">
              {{pageGrpForm.heroImageContent.heroImageName}}</div>
          </div>
        </div>
        <div id="uploadFormLayout3" class="form-group-upload" *ngIf="pageGrpForm.layout === 3">
          <label for="heroImage">
            <span i18n="@@partner-content-page.video.video">Video</span> <span class="coral">*</span>
            &nbsp; <img class="round-info-icon" placement="top" [ngbPopover]="popContentVideo"
            container="body" alt="font color content" triggers="mouseenter:mouseleave" />             
            <img class="image_icon" alt="hero image" />
          </label>
          <button type="button" class="btn btn-primary left_icon_btn" (click)="openPopup(imagePopup,'video')">
            <img class="video_icon" alt="add image" />
            <span i18n="@@partner-content-page.upload-video.upload-video">Upload Video</span>
          </button>
          <div id="videoName" class="name-break" *ngIf="pageGrpForm.videoContent.videoName"
            ngbTooltip="{{pageGrpForm.videoContent.videoName}}">
            {{pageGrpForm.videoContent.videoName}}</div>
        </div>
        <div class="d-flex">
          <div id="uploadFormHotspotLayout4" class="form-group d-flex" *ngIf="pageGrpForm.layout === 4">
            <div>
              <label for="bodyCopyA">
                <span i18n="@@partner-content-page.body.body">Body</span>
                <span class="text-muted ml-1" i18n="@@partner-content-page.max-body.max-2000-characters">(Max 2000
                  characters)</span>
              </label>
              <div id="inputTextArea" class="input-group">
                <textarea class="form-control" name="body" (keyup)="emitPageDataToPreview()"
                  [(ngModel)]="pageGrpForm.hotspotImageVideoContent.body" (ngModelChange)="onBodyChange($event)"
                  maxlength="2000" id="bodyCopy" rows="3" [placeholder]="bodyPlaceHolderText"></textarea>
              </div>
              <div [ngClass]="{'standDiv': isMaxLengthReached}">
                <span class="formfield_err_msg" *ngIf="isMaxLengthReached">Body Text cannot be more than 2000
                  characters.</span>
              </div>
            </div>
            <div id="ColorPicker" class="color-picker-group">
              <label for=""><span i18n="@@page.content.color">Color</span></label>
              <div></div>
              <input readonly [(colorPicker)]="pageGrpForm.hotspotImageVideoContent.bodyColor" [cpPosition]="'right'"
                [style.background]="pageGrpForm.hotspotImageVideoContent.bodyColor" class="color_picker_button"
                name="Bodycolor" (colorPickerChange)="onHeadingBodyColorChange()"
                [ngClass]="{'hotspot_input': pageGrpForm.layout === 4}" />
            </div>
            <div class="size-hotspot-section">
              <div></div>
              <div id="singleImageDropdown" ngbDropdown class="btn-group"
                [ngClass]="{'align-self-center':pageGrpForm.layout === 4}">
                <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                  id="singleImageSizeDropDown" aria-haspopup="true" aria-expanded="false">
                  {{pageGrpForm.hotspotImageVideoContent.bodyFontSize}}</button>
                <div id="sizeDropdown" class="size-dropdown" ngbDropdownMenu aria-labelledby="singleImageSizeDropDown">
                  <a ngbDropdownItem *ngIf="pageGrpForm.hotspotImageVideoContent.bodyFontSize!=smallText"
                    (click)="selectHotspotBodySize('Small')">{{smallText}}</a>
                  <a ngbDropdownItem *ngIf="pageGrpForm.hotspotImageVideoContent.bodyFontSize!=mediumText"
                    (click)="selectHotspotBodySize('Medium')">{{mediumText}}</a>
                  <a ngbDropdownItem *ngIf="pageGrpForm.hotspotImageVideoContent.bodyFontSize!=largeText"
                    (click)="selectHotspotBodySize('Large')">{{largeText}}</a>
                </div>
              </div>
            </div>
          </div>
          <div id="uploadFormLayout2" class="form-group" *ngIf="pageGrpForm.layout === 2">
            <label for="bodyCopyA">
              <span i18n="@@partner-content-page.body.body">Body</span>
              <span class="text-muted ml-1" i18n="@@partner-content-page.max-body.max-250-characters">(Max 250
                characters)</span>
            </label>
            <div id="inputTextArea" class="input-group">
              <textarea class="form-control" name="body" (keyup)="emitPageDataToPreview()"
                [(ngModel)]="pageGrpForm.singleImageContent.body" maxlength="250" id="bodyCopy" rows="3"
                [placeholder]="bodyPlaceHolderText"></textarea>
              <div id="singleImageDropdown" ngbDropdown class="btn-group">
                <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                  id="singleImageSizeDropDown" aria-haspopup="true" aria-expanded="false">
                  {{pageGrpForm.singleImageContent.size}}</button>
                <div id="sizeDropdown" class="size-dropdown" ngbDropdownMenu aria-labelledby="singleImageSizeDropDown">
                  <a ngbDropdownItem *ngIf="pageGrpForm.singleImageContent.size!=smallText"
                    (click)="selectSize('Small')">{{smallText}}</a>
                  <a ngbDropdownItem *ngIf="pageGrpForm.singleImageContent.size!=mediumText"
                    (click)="selectSize('Medium')">{{mediumText}}</a>
                  <a ngbDropdownItem *ngIf="pageGrpForm.singleImageContent.size!=largeText"
                    (click)="selectSize('Large')">{{largeText}}</a>
                </div>
              </div>
            </div>
          </div>
          <div id="formLayout1" class="form-group" *ngIf="pageGrpForm.layout === 1">
            <label for="bodyCopyA">
              <span i18n="@@partner-content-page.body-a.body-a">Body A</span>
              <span class="text-muted ml-1" i18n="@@partner-content-page.max-heading.max-50-characters">(Max 100
                characters)</span>
            </label>
            <div id="bodyAInputText" class="input-group">
              <input type="text" class="form-control" id="bodyA" [placeholder]="bodyAPlaceHolder"
                [(ngModel)]="pageGrpForm.imageAContent.bodyA" name="bodyA" (keyup)="emitPageDataToPreview()"
                maxlength="100" />
              <div id="bodyASizeDropdown" ngbDropdown class="btn-group">
                <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle" id="imageASizeDropDown"
                  aria-haspopup="true" aria-expanded="false">
                  {{pageGrpForm.imageAContent.bodyASize}}</button>
                <div id="imageASizeDropdown" class="size-dropdown" ngbDropdownMenu aria-labelledby="imageASizeDropDown">
                  <a ngbDropdownItem *ngIf="pageGrpForm.imageAContent.bodyASize!=smallText"
                    (click)="selectSizeA('Small')">{{smallText}}</a>
                  <a ngbDropdownItem *ngIf="pageGrpForm.imageAContent.bodyASize!=mediumText"
                    (click)="selectSizeA('Medium')">{{mediumText}}</a>
                  <a ngbDropdownItem *ngIf="pageGrpForm.imageAContent.bodyASize!=largeText"
                    (click)="selectSizeA('Large')">{{largeText}}</a>
                </div>
              </div>
            </div>
          </div>
          <div id="uploadFormLayout1" class="form-group-upload" *ngIf="pageGrpForm.layout === 1">
            <label for="heroImage">
              <span i18n="@@partner-content-page.image-a.image-a">Image A</span> <span class="coral">*</span>
              &nbsp; <img class="round-info-icon" placement="top" [ngbPopover]="popContentImage"
              container="body" alt="font color content" triggers="mouseenter:mouseleave" />               
              <img class="image_icon" alt="Image A" />
            </label>
            <button type="button" class="btn btn-primary left_icon_btn" (click)="openPopup(imagePopup,'imageA')">
              <img class="image_icon" alt="Add Image" />
              <span i18n="@@partner-content-page.add-image.add-image">Add Image</span>
            </button>
            <div id="imageAName" class="name-break" *ngIf="pageGrpForm.imageAContent.imageAName"
              ngbTooltip="{{pageGrpForm.imageAContent.imageAName}}">
              {{pageGrpForm.imageAContent.imageAName}}</div>
          </div>
        </div>
        <!--save hotspot button-->
        <div id="savehtspotBtn" class="pages_tabs" *ngIf="pageGrpForm.layout === 4">
          <div id="saveHotspotBtnWrapper" class="button-wrapper pages_button">
            <button type="button" [disabled]="disabledSaveHotspot" class="btn btn-primary" (click)="saveHotspot()">
              <span i18n="@@partner-content-page.save-hotspot-btn.save-hotspot">Save Hotspot</span>
            </button>
          </div>
        </div>
        <div class="d-flex">
          <div id="bodyBFormLayout1" class="form-group" *ngIf="pageGrpForm.layout === 1">
            <label for="bodyCopyB">
              <span i18n="@@partner-content-page.body-b.body-b">Body B</span>
              <span class="text-muted ml-1" i18n="@@partner-content-page.max-heading.max-50-characters">(Max 100
                characters)</span>
            </label>
            <div id="bodyBInputPlaceHolder" class="input-group">
              <input type="text" class="form-control" id="bodyB" [placeholder]="bodyBPlaceHolder"
                [(ngModel)]="pageGrpForm.imageBContent.bodyB" name="bodyB" (keyup)="emitPageDataToPreview()"
                maxlength="100" />
              <div id="dropdownBtn" ngbDropdown class="btn-group">
                <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle" id="imageBSizeDropDown"
                  aria-haspopup="true" aria-expanded="false">
                  {{pageGrpForm.imageBContent.bodyBSize}}</button>
                <div id="imageBSizeDropdown" class="size-dropdown" ngbDropdownMenu aria-labelledby="imageBSizeDropDown">
                  <a ngbDropdownItem *ngIf="pageGrpForm.imageBContent.bodyBSize!=smallText"
                    (click)="selectSizeB('Small')">{{smallText}}</a>
                  <a ngbDropdownItem *ngIf="pageGrpForm.imageBContent.bodyBSize!=mediumText"
                    (click)="selectSizeB('Medium')">{{mediumText}}</a>
                  <a ngbDropdownItem *ngIf="pageGrpForm.imageBContent.bodyBSize!=largeText"
                    (click)="selectSizeB('Large')">{{largeText}}</a>
                </div>
              </div>
            </div>
          </div>
          <div id="imageBFormLayout1" class="form-group-upload" *ngIf="pageGrpForm.layout === 1">
            <label for="heroImage">
              <span i18n="@@partner-content-page.image-b.image-b">Image B</span> <span class="coral">*</span>
              &nbsp; <img class="round-info-icon" placement="top" [ngbPopover]="popContentImage"
              container="body" alt="font color content" triggers="mouseenter:mouseleave" />               
              <img class="image_icon" alt="Image B" />
            </label>
            <button type="button" class="btn btn-primary left_icon_btn" (click)="openPopup(imagePopup,'imageB')">
              <img class="image_icon" alt="Add Image B" />
              <span i18n="@@partner-content-page.add-image.add-image">Add Image</span>
            </button>
            <div id="imageBName" class="name-break" *ngIf="pageGrpForm.imageBContent.imageBName"
              ngbTooltip="{{pageGrpForm.imageBContent.imageBName}}">
              {{pageGrpForm.imageBContent.imageBName}}</div>
          </div>
        </div>
      </div>
      <div *ngIf="pageGrpForm.layout !== 4" class="inline_separator"></div>

      <!-- 3rd Column - Logo Info -->
      <div>
        <div id="column3UploadLayout2" class="form-group-upload" *ngIf="pageGrpForm.layout === 2">
          <label for="heroImage">
            <span i18n="@@partner-content-page.image.image">Image</span> <span class="coral">*</span>
            &nbsp; <img class="round-info-icon" placement="top" [ngbPopover]="popContentImage"
            container="body" alt="font color content" triggers="mouseenter:mouseleave" />             
            <img class="image_icon" alt="hero image" />
          </label>
          <button type="button" class="btn btn-primary left_icon_btn" (click)="openPopup(imagePopup,'image')">
            <img class="image_icon" alt="add image" />
            <span i18n="@@partner-content-page.add-image.add-image">Add Image</span>
          </button>
          <div id="column2ImageName" class="name-break" *ngIf="pageGrpForm.singleImageContent.imageName"
            ngbTooltip="{{pageGrpForm.singleImageContent.imageName}}">
            {{pageGrpForm.singleImageContent.imageName}}</div>
        </div>
        <div id="logoUpload" class="form-group-upload" *ngIf="pageGrpForm.layout !== 4">
          <label for="logo">
            <span i18n="@@partner-content-page.logo.logo">Logo</span>
          </label>
          <button type="button" class="btn btn-primary left_icon_btn" (click)="openPopup(imagePopup,'logo')">
            <img class="logo_icon_btn" alt="logo button" />
            <span i18n="@@partner-content-page.add-logo.add-logo">Add Logo</span>
          </button>
          <div id="logoMediaName" class="name-break" *ngIf="pageGrpForm.logoMedia.name"
            ngbTooltip="{{pageGrpForm.logoMedia.name}}">
            {{pageGrpForm.logoMedia.name}}</div>
        </div>

      </div>
    </form>
  </div>
  <ng-template #imagePopup let-modal>
    <div id="imagePopupModal" class="modal-backdrop show"></div>
    <div class="modal" id="tileThumbnailPopup" role="dialog">
      <div id="imagePopupModalDialog" class="modal-dialog odal-dialog-centered" role="document">
        <div id="imagePopupModalContent" class="modal-content">
          <div id="popupModalCloseIcon" class="close" data-dismiss="modal" (click)="closePopup(modal)">
            <img class="modal-close-icon" alt="close" />
          </div>
          <div id="imagePopupModalBody" class="modal-body">
            <div id="popupModalHeading" class="d-flex align-items-center mb-4">
              <h2 class="heading">
                <div id="popupModalSystemId" class="system_break" placement="bottom-left" container='body'
                  ngbTooltip="{{systemID}}">
                  {{systemID}}</div>
              </h2>
              <span
                *ngIf="imageButtonType === 'hero' || imageButtonType === 'imageA' || imageButtonType === 'imageB' || imageButtonType === 'image'">Images</span>
              <span *ngIf="imageButtonType === 'video'"><span
                  i18n="@@partner-content-page.videos-videos">Videos</span></span>
              <span *ngIf="imageButtonType === 'logo'"><span
                  i18n="@@partner-content-page.logos-logos">Logos</span></span>
              <span *ngIf="imageButtonType === 'image-video'"><span>Image/Video</span></span>
            </div>
            <ng-container *ngIf="(!isAssetDataEmpty && !isVideoButton) || (isVideoButton && !isVideoAssetDataEmpty)">
              <iposcen-spinner-overlay></iposcen-spinner-overlay>
            </ng-container>
            <div class="filter_options" *ngIf="pageGrpForm.layout === 4 && imageButtonType === 'image-video'"
              id="filterOptionaImageorVideo">
              <div class="form-inline" id="frmInline">
                <span id="filterfont" class="mr-4" i18n="@@active-users.filter-options.filters">Filters</span>
                <div id="ngbdropDown" ngbDropdown class="border-secondory btn-sm btn btn-outline" name="selectFilter"
                  value="selectFilter">
                  <button ngbDropdownToggle class="btn-sm btn custom-btn" type="button" id="dropdownMenuButton"
                    data-bs-toggle='dropdown' aria-haspopup="true" aria-expanded="false">
                    {{selectedFilter}}
                  </button>
                  <div id="ngbDropdownMenu" ngbDropdownMenu class="dropdown-menu custom-dropdown-menu"
                    aria-labelledby="dropdownMenuButton">
                    <span id="All" *ngIf="selectedFilter !== 'All'" class="dropdown-item custom-dn-item"
                      (click)="filterImageOrVideo('All')">All</span>
                    <span id="Images" *ngIf="selectedFilter !== 'Images'" class="dropdown-item custom-dn-item"
                      (click)="filterImageOrVideo('Images')">Images</span>
                    <span id="Videos" *ngIf="selectedFilter !== 'Videos'" class="dropdown-item custom-dn-item"
                      (click)="filterImageOrVideo('Videos')">Videos</span>
                  </div>
                </div>
              </div>
            </div>
            <div id="notVideoButton" class="row" *ngIf="!isVideoButton && !isImageVideoButton">
              <div id="emptyAssetData" class="text-center" *ngIf="isAssetDataEmpty && !(imageButtonType === 'logo')">
                <span
                  i18n="@@partner-content-page.no-assets-page.no-assets-found-please-add-assets-by-uploading-it-from-here">No
                  assets found. Please add assets by uploading them from <a class="here-link"
                    (click)="redirectToModelSku(modal)">here</a>.</span>
              </div>
              <div id="logoImageButton" class="text-center" *ngIf="isAssetDataEmpty && imageButtonType === 'logo'"><span
                  i18n="@@partner-content-page.no-assets-page.no-assets-found-please-add-assets-by-uploading-it-from-here">No
                  assets found. Please add assets by uploading them from <a class="here-link"
                    (click)="redirectToModelSku(modal)">here</a>.</span></div>
              <div id="imageData" class="col-3" *ngFor="let imageData of image">
                <div id="imageCard" class="card" [ngClass]="imageData.selectedImage?'active':''">
                  <img [src]="imageData.imageData" class="card-img-top" alt="Image upload"
                    (click)="selectImage(imageData.assetID,imageData, '')">
                  <div id="imageCardFooter" class="card-footer">{{imageData.assetName}}</div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="isVideoButton" id="videoPopup">
              <div id="buttonTypeVideo" class="text-center"
                *ngIf="isVideoAssetDataEmpty && imageButtonType === 'video'"><span
                  i18n="@@partner-content-page.no-assets-page.no-assets-found-please-add-assets-by-uploading-it-from-here">No
                  assets found. Please add assets by uploading them from <a class="here-link"
                    (click)="redirectToModelSku(modal)">here</a>.</span></div>
              <div id="videoData" class="col-3" *ngFor="let video of tileVideo">
                <div id="selectedVideoCard" class="card" [ngClass]="video.selectedVideo?'active':''"
                  (click)="selectVideo(video.assetID,video, '')">
                  <video (play)='checkVideoPlay($event)' controls>
                    <source [src]="video.videoData" type="video/mp4" />
                  </video>
                  <div id="videoCardFooter" class="card-footer">{{video.assetName}}</div>
                </div>
              </div>
            </div>
            <!--For AIIP-133 pop-up-->
            <div class="row image-video-popup" *ngIf="!isVideoButton && isImageVideoButton" id="imagevideoPopup">
              <div id="buttonTypeVideo" class="text-center"
                *ngIf="isVideoAssetDataEmpty && isAssetDataEmpty && imageButtonType === 'image-video'"><span
                  i18n="@@partner-content-page.no-assets-page.no-assets-found-please-add-assets-by-uploading-it-from-here">No
                  assets found. Please add assets by uploading them from <a class="here-link"
                    (click)="redirectToModelSku(modal)">here</a>.</span></div>
              <ng-container *ngIf="selectedFilter === 'All' || selectedFilter === 'Videos'">
                <div id="videoData" class="col-3" *ngFor="let video of tileVideo">
                  <div id="selectedVideoCard" class="card" [ngClass]="video.selectedVideo?'active':''"
                    (click)="selectVideo(video.assetID,video, 'hotspot')">
                    <video (play)='checkVideoPlay($event)' controls>
                      <source [src]="video.videoData" type="video/mp4" />
                    </video>
                    <div id="videoCardFooter" class="card-footer">{{video.assetName}}</div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="selectedFilter === 'All' || selectedFilter === 'Images'">
                <div id="imageData" class="col-3" *ngFor="let imageData of image">
                  <div id="imageCard" class="card" [ngClass]="imageData.selectedImage?'active':''">
                    <img [src]="imageData.imageData" class="card-img-top" alt="Image upload"
                      (click)="selectImage(imageData.assetID,imageData, 'hotspot')">
                    <div id="imageCardFooter" class="card-footer">{{imageData.assetName}}</div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div id="imageModalFooter" class="modal-footer"
            *ngIf="(!isVideoButton && image.length) || (isVideoButton && tileVideo.length) || (isImageVideoButton && (image.length || tileVideo.length))">
            <button (click)="closePopup(modal)" type="button" class="btn btn-outline-primary" data-dismiss="modal">
              <span i18n="@@partner-content-page.cancel-cancel">Cancel</span>
            </button>
            <button [disabled]="disableImage" *ngIf="!isVideoButton && image.length && !isImageVideoButton"
              type="button" (click)="addImage(modal)" class="btn btn-primary gtmUsersAddDomains">
              <span i18n="@@partner-content-page.add-image.add-image">Add Image</span>
            </button>
            <button [disabled]="disableVideo" *ngIf="isVideoButton && tileVideo.length" type="button"
              (click)="addVideo(modal)" class="btn btn-primary gtmUsersAddDomains">
              <span i18n="@@partner-content-page.add-video.add-video">Add Video</span>
            </button>
            <button [disabled]="disableVideo && disableImage"
              *ngIf="isImageVideoButton && (image.length || tileVideo.length)" type="button" class="btn btn-primary"
              (click)="addThumbanail(modal)">
              <span>Select Thumbnail</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #colorpicker>
    <div id="colorPickerCard" class="card" dir={{direction}}>
      <div id="colorPickerPopupBody" class="popup-body">
        <div id="colorPickerModalHeader" class="modal-header p-0">
          <div id="colorPickerCloseIcon" (click)="dismiss()" class="close_icon popup_close">
            <img src="assets/images/popup_close_button.svg" alt="color picker" class="cursor-pointer" />
          </div>
        </div>
        <div id="themePickerModalBody" class="modal-body p-0">
          <div id="themePick" class="card">
            <div id="themePickerModalHeader" class="theme_pick_header" [style.background-color]="pageGrpForm.bgcolor">
              <div id="themePickerModalTitle" class="theme_pick_title" [style.color]="pageGrpForm.hcolor">
                {{pageGrpForm.heading === ''?
                headingLabel:pageGrpForm.heroImageContent.heading}}</div>
              <div id="themePickerModalSubtitle" class="theme_pick_subtitle"
                [ngStyle]="{'color':pageGrpForm.bcolor,'font-size':fontSize(pageGrpForm.layoutContent[2].size)}">
                {{pageGrpForm.layoutContent[2].body ===
                ''? bodyLabel:pageGrpForm.layoutContent[2].body}}</div>
            </div>
            <div id="themePickerText" class="theme_pick_text">
              <span class="optional-text"><span i18n="@@partner-content-page.optional-optional">Optional</span></span>:
              <span
                i18n="@@partner-content-page.accessibility.ensure-accesibility-by-choosing-from-wcag-2.0-aa-complint-themes">Ensure
                accessibility by choosing from WCAG 2.0
                AA-compliant themes.</span>
            </div>
            <div id="themeColorInfo" class="theme_color mb-3">
              <div id="blueThemeWrapper" class="theme-wrapper">
                <div id="blueThemePicker" class="theme_picker_button default"
                  (click)="chooseTheme('#ffffff','#0068B5')">
                  <span class="text_color text_color_white"></span>
                  <span class="bg_color bg_color_blue_shade"></span>
                </div>
                <span [ngClass]="{'color_highlighter': isSelected('#ffffff','#0068B5' )}"></span>
              </div>
              <div id="redThemeWrapper" class="theme-wrapper">
                <div id="redThemePicker" class="theme_picker_button default" (click)="chooseTheme('#ffffff','#C81326')">
                  <span class="text_color text_color_white"></span>
                  <span class="bg_color bg_color_red"></span>
                </div>
                <span [ngClass]="{'color_highlighter': isSelected('#ffffff','#C81326')}"></span>
              </div>
              <div id="maroonThemeWrapper" class="theme-wrapper">
                <div id="maroonThemePicker" class="theme_picker_button default"
                  (click)="chooseTheme('#ffffff','#653171')">
                  <span class="text_color text_color_white"></span>
                  <span class="bg_color bg_color_maroon"></span>
                </div>
                <span [ngClass]="{'color_highlighter': isSelected('#ffffff','#653171')}"></span>
              </div>
              <div id="yellowThemeWrapper" class="theme-wrapper">
                <div id="yellowThemePicker" class="theme_picker_button default"
                  (click)="chooseTheme('#F6CB4B','#1E2EB8')">
                  <span class=" text_color text_color_yellow"></span>
                  <span class="bg_color bg_color_blue_shadee"></span>
                </div>
                <span [ngClass]="{'color_highlighter': isSelected('#F6CB4B','#1E2EB8')}"></span>
              </div>
              <div id="greyThemeWrapper" class="theme-wrapper">
                <div id="greyThemePicker" class="theme_picker_button default"
                  (click)="chooseTheme('#000964','#AEAEAE')">
                  <span class="text_color text_color_dark_blue"></span>
                  <span class="bg_color bg_color_grey"></span>
                </div>
                <span [ngClass]="{'color_highlighter': isSelected('#000964','#AEAEAE')}"></span>
              </div>
            </div>
            <div id="themeColorInfo2" class="theme_color">
              <div id="purpleThemeWrapper" class="theme-wrapper">
                <div id="purpleThemePicker" class="theme_picker_button default"
                  (click)="chooseTheme('#262626','#98A1FF')">
                  <span class="text_color text_color_black"></span>
                  <span class="bg_color bg_color_light_purple"></span>
                </div>
                <span [ngClass]="{'color_highlighter': isSelected('#262626','#98A1FF')}"></span>
              </div>
              <div id="lightBlueThemeWrapper" class="theme-wrapper">
                <div id="lightBlueThemePicker" class="theme_picker_button default"
                  (click)="chooseTheme('#262626','#00C7FD')">
                  <span class="text_color text_color_black"></span>
                  <span class="bg_color bg_color_light_blue"></span>
                </div>
                <span [ngClass]="{'color_highlighter': isSelected('#262626','#00C7FD')}"></span>
              </div>
              <div id="lightGreenThemeWrapper" class="theme-wrapper">
                <div id="lightGreenThemePicker" class="theme_picker_button default"
                  (click)="chooseTheme('#8BAE46','#262626')">
                  <span class="text_color text_color_light_green"></span>
                  <span class="bg_color bg_color_black"></span>
                </div>
                <span [ngClass]="{'color_highlighter': isSelected('#8BAE46','#262626')}"></span>
              </div>
            </div>
            <div id="themeCardFooter" class="card-footer">
              <button type="button" class="btn btn-outline-primary gtmAssetLibraryPageUseDefault"
                (click)="chooseTheme('#ffffff','#0068B5')">
                <span i18n="@@partner-content-page.use-default-use-defualt">Use Default</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <hr>
  <div id="logoUpload" class="form-group-upload" *ngIf="pageGrpForm?.layout === 4">
    <label for="logo">
      <span i18n="@@partner-content-page.logo.logo">Logo</span>
    </label>
    <button type="button" class="btn btn-primary left_icon_btn" (click)="openPopup(imagePopup,'logo')">
      <img class="new_logo_icon_btn" alt="logo button" />
      <span i18n="@@profile-storelogo.store-logos-tab.upload-logo">Upload Logo</span>
    </button>
    <div id="logoMediaName" class="name-break" *ngIf="pageGrpForm?.logoMedia?.name"
      ngbTooltip="{{pageGrpForm?.logoMedia?.name}}">
      {{pageGrpForm?.logoMedia?.name}}</div>
  </div>
  <ng-template #popContent class="popover-new">
    <div id="popOverUpload" class="popover-upload-req">
      <div id="imgVideoSizeInfo" class="d-flex align-items-center">
        <img src="assets/images/image-icon.png" alt="image" />
        <ul>
          <li i18n="@@global.tooltip.image-rule-format">Images must be in <strong>JPG, PNG, JPEG,
              JFIF</strong> or <strong>GIF</strong> format</li>
          <li><span
              i18n="@@global.tooltip.image-max-size-error">Allowed maximum size is <strong>5
                MB</strong></span></li>
                <li [innerHTML] = aspectRatioText></li>
        </ul>
      </div>
      <hr />
      <div id="ImgVideoSizeInfoEnabled" class="d-flex align-items-center">
        <img src="assets/images/video-icon.png" alt="video" />
        <ul>
          <li i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong> format
          </li>
          <li>Allowed
            maximum length is <strong>180 seconds</strong></li>
          <li>Allowed
            maximum size is <strong>30 MB</strong></li>
        </ul>
      </div>
    </div>
  </ng-template>
  <ng-template #popContentImage class="popover-new">
    <div id="popOverUpload" class="popover-upload-req">
      <div id="imgVideoSizeInfo" class="d-flex align-items-center">
        <img src="assets/images/image-icon.png" alt="image" />
        <ul>
          <li i18n="@@global.tooltip.image-rule-format">Images must be in <strong>JPG, PNG, JPEG,
              JFIF</strong> or <strong>GIF</strong> format</li>
          <li><span
              i18n="@@global.tooltip.image-max-size-error">Allowed maximum size is <strong>5
                MB</strong></span></li>
                <li [innerHTML] = aspectRatioText></li>
        </ul>
      </div>     
    </div>
  </ng-template>
  <ng-template #popContentVideo class="popover-new">
    <div id="popOverUpload" class="popover-upload-req">
      <div id="ImgVideoSizeInfoEnabled" class="d-flex align-items-center">
        <img src="assets/images/video-icon.png" alt="video" />
        <ul>
          <li i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong> format
          </li>
          <li>Allowed
            maximum length is <strong>180 seconds</strong></li>
          <li>Allowed
            maximum size is <strong>30 MB</strong></li>
        </ul>
      </div>
    </div>
  </ng-template>      
</div>